import { connect } from 'react-redux'
import { vpnActions, notifyActions } from '../store/actions';
import pageVpn from './pages/box';

const mapStateToProps = state => {
    return {
        ...state,
        user: state.user,
        vpn: state.vpn,
        role: state.role,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setIdVpnPassForDetail: (data) => {
            dispatch(vpnActions.setIdVpnPassForDetail(data))
        },
        setKeyVpnPassForDetail: (data) => {
            dispatch(vpnActions.setKeyVpnPassForDetail(data))
        },
        setNumberVpnBox: (data) => {
            dispatch(vpnActions.setNumberVpnBox(data))
        },
        successNotify: (message) => {
            dispatch(notifyActions.successAction(message))
        },
        warningNotify: (message) => {
            dispatch(notifyActions.warningAction(message))
        },
        errorNotify: (message) => {
            dispatch(notifyActions.errorAction(message))
        },
        infoNotify: (message) => {
            dispatch(notifyActions.infoAction(message))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageVpn);